import LayoutWithSidebar from "../components/LayoutWithSidebar";
import MainHeaderContainer from "../containers/MainHeaderContainer";
import MainSideMenu from "../components/MainSideMenu";
import MyProjectsList from "../components/MyProjectsList";
import { Grid } from "semantic-ui-react";
import NotificationsListContainer from "../containers/NotificationsListContainer";

const HomePage = () => {
  const headerContent = () => {
    return <MainHeaderContainer></MainHeaderContainer>;
  };

  const sidebarContent = () => {
    return <MainSideMenu></MainSideMenu>;
  };

  const contentPanelContent = () => {
    return (
      <Grid columns={2}>
        <Grid.Column width={10}>
          <MyProjectsList></MyProjectsList>
        </Grid.Column>
        <Grid.Column width={6}>
          <NotificationsListContainer />
        </Grid.Column>
      </Grid>
    );
  };

  return (
    <LayoutWithSidebar
      headerContent={headerContent()}
      sidebarContent={sidebarContent()}
      mainPanelContent={contentPanelContent()}
    ></LayoutWithSidebar>
  );
};

export default HomePage;
